export default "__VITE_PUBLIC_ASSET__0f81c100__"